import { ADDRESS_INPUT_ID, MAP_CONTAINER_ID } from './constants';

export const suggestionsMixin = {
	methods: {
		async getSuggestionsOptions(suggestionType)
		{
			try
			{
				const response = await BX.ajax.runAction(
					'corsik:yadelivery.Checkout.Suggestions.getOptions',
					{ data: { suggestionType } },
				);

				if (response.status !== 'success')
				{
					if (response.errors?.length > 0)
					{
						console.error(response.errors);
					}

					return null;
				}

				return response.data;
			}
			catch (error)
			{
				console.error(error);
				return null;
			}
		},

		parseSuggestionsRestriction()
		{
			const raw = this.params.suggestionsRestriction;
			if (!raw)
			{
				return [];
			}

			try
			{
				const parsed = JSON.parse(raw);
				return Array.isArray(parsed) ? parsed : [];
			}
			catch
			{
				return [];
			}
		},

		getDadataSuggestionsSettings()
		{
			const restrictions = this.parseSuggestionsRestriction();
			const params = {};

			if (restrictions.length > 0)
			{
				// Core DadataSuggestion reads field params.restriction (singular) — see
				// DadataSuggestion.getOptions(); the plural key was silently ignored.
				params.restriction = restrictions.map(({ id }) => ({ kladr_id: id }));
			}

			return [
				{
					code: 'ADDRESS',
					selector: `#${ADDRESS_INPUT_ID}`,
					params,
				},
			];
		},

		getYandexSuggestionsSettings()
		{
			const restrictions = this.parseSuggestionsRestriction();
			const params = {};

			if (restrictions.length > 0)
			{
				const prefix = restrictions.map(({ value }) => value).join(', ') + ', ';
				params.options = {
					provider: {
						suggest: (request) => ymaps.suggest(prefix + request),
					},
				};
			}

			return [
				{
					code: 'ADDRESS',
					selector: `#${ADDRESS_INPUT_ID}`,
					params,
				},
			];
		},

		getComponentSettings()
		{
			const { displayMap, typePrompts, personType, startPrice, addZonePrice,
				hideCostField, hideWeightField, currency, mapSettings, showModalBalloon } = this.params;

			const isDadata = typePrompts === 'dadata';
			const isYandex = typePrompts === 'yandex';
			const isInfoBalloon = showModalBalloon !== false;

			const currentMapSettings = {
				...mapSettings,
				points: {
					...mapSettings.points,
					warehouse: this.selectedWarehouse,
				},
			};

			return {
				displayMap, typePrompts, personType, startPrice, addZonePrice,
				hideCostField, hideWeightField, currency, showModalBalloon,
				mapSettings: currentMapSettings,
				selectors: this.isPageMap ? { map: `#${MAP_CONTAINER_ID}` } : {},
				yandex: {
					mapContainer: `#${MAP_CONTAINER_ID}`,
					controls: true,
					options: {
						search: { size: 'auto' },
					},
					fields: (this.params.enableSuggestions && isYandex) ? this.getYandexSuggestionsSettings() : [],
				},
				dadata: {
					fields: (this.params.enableSuggestions && isDadata) ? this.getDadataSuggestionsSettings() : [],
				},
				view: {
					balloon: {
						show: isInfoBalloon,
						showApplyButton: !this.isPageMap,
					},
				},
			};
		},
	},
};
